import { render, staticRenderFns } from "./insurers.vue?vue&type=template&id=4cb1b7e2&scoped=true"
import script from "./insurers.vue?vue&type=script&lang=js"
export * from "./insurers.vue?vue&type=script&lang=js"
import style0 from "./insurers.vue?vue&type=style&index=0&id=4cb1b7e2&prod&lang=css"
import style1 from "./insurers.vue?vue&type=style&index=1&id=4cb1b7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1b7e2",
  null
  
)

export default component.exports